import React from 'react';
import { Formik } from 'formik';
import { ModalWithStyles } from './ModalWithStyles';
import { IUserAtom } from '../../../recoil/atoms/user';
import { SetterOrUpdater } from 'recoil';
import { IAlertWithProgressBar } from '../notifications/SnackbarProviderWithStyles';
import { OptionsObject, SnackbarKey } from 'notistack';
import { useDeletePowerlistContactMutation } from '../../../api/apigQuery';
import { GridRowData } from '@mui/x-data-grid';

export function DeleteContactModal(props: {
  setRefetchToggleForPowerlistContacts: SetterOrUpdater<{}>;
  enqueueSnackbarWithStyles: (
    alertComponentProps: IAlertWithProgressBar,
    snackbarProps?: OptionsObject | undefined
  ) => SnackbarKey | null;
  selected: GridRowData[];
  show: boolean;
  userAtom: IUserAtom;
  deletePowerlistContactMutation: ReturnType<
    typeof useDeletePowerlistContactMutation
  >[0];
  handleClose: () => void;
}) {
  return (
    <Formik
      onSubmit={async (values, actions) => {
        let contactsNotDeleted = 0; // count user selected contacts skipped from deletion
        let contactsAlreadyDeleted = 0; // a count of contacts that have already been deleted
        if (props.selected.length) {
          for (let i = 0; i < values.selected.length; i++) {
            if (values.selected[i].status === 'removed') {
              contactsAlreadyDeleted++;
              continue;
            }
            if (values.selected[i].status !== 'answeredWaitingForOutcome') {
              // Only delete contacts with status NOT answeredWaitingForOutcome
              const response = await props.deletePowerlistContactMutation({
                userSettings: {
                  apikey: props.userAtom.apikey,
                  businessId: props.userAtom.businessid,
                  businessid: props.userAtom.businessid,
                  userId: props.userAtom.userid,
                  userid: props.userAtom.userid,
                },
                powerlistContactId: values.selected[i].powerlistContactId,
              });
              if (
                !response ||
                'error' in response ||
                ('data' in response && !response.data.success)
              ) {
                // eslint-disable-next-line no-console
                console.error(
                  'deletePowerlistContactMutation failed: ',
                  response
                );
                props.enqueueSnackbarWithStyles({
                  message:
                    'Looks like we encountered an error deleting these Contacts(s)',
                  alertProps: { severity: 'warning' },
                });
                break;
              }
            } else {
              contactsNotDeleted++; // increment the count of contacts skipped from deletion
            }
          }
          props.setRefetchToggleForPowerlistContacts({});
          const contactsDeleted =
            values.selected.length -
            contactsNotDeleted -
            contactsAlreadyDeleted; // user selected contacts to delete minus the skipped contacts
          if (contactsDeleted > 0) {
            // only show the success count if there were contacts deleted
            props.enqueueSnackbarWithStyles({
              message: `Successfully Deleted ${contactsDeleted} Contacts(s)`,
              alertProps: { severity: 'success' },
            });
          }
          if (contactsNotDeleted > 0) {
            // show users the count of users skipped from deletion
            props.enqueueSnackbarWithStyles({
              message: `${contactsNotDeleted} Contact(s) waiting for outcome were skipped and cannot be deleted.`,
              alertProps: { severity: 'error' },
            });
          }
          if (contactsAlreadyDeleted === values.selected.length) {
            // if (contactsAlreadyDeleted > 0) {
            props.enqueueSnackbarWithStyles({
              message: `Contacts were already deleted.`,
              alertProps: { severity: 'warning' },
            });
          }
          props.handleClose();
          actions.resetForm({});
        }
      }}
      enableReinitialize={true}
      initialValues={{ selected: props.selected ?? [] }}
    >
      {(formik) => (
        <ModalWithStyles
          onSubmit={formik.handleSubmit}
          title="Delete Contacts(s)"
          aria-labelledby="example-modal-sizes-title-md"
          show={props.show}
          onHide={props.handleClose}
          isSubmitting={formik.isSubmitting}
          isLoading={formik.isSubmitting}
          deleteDialog={true}
          size="xs"
        >
          <p>
            You are about to delete {formik.values.selected.length} Contacts(s),
            this procedure is not reversible.
          </p>
          <p> Do you want to proceed?</p>
        </ModalWithStyles>
      )}
    </Formik>
  );
}
